// Toggle interactivity - use jQuery SlideToggle if needed
(function($){
    $(document).on('click', '.toggle .toggle-header', function() {
        $(this).next().slideToggle("300", function () {
            $(this).parent().toggleClass("expanded");
        });
    });
})(jQuery);

